import type { UserAdminService } from '@nebalkon-workspace/admin-api';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export async function resolveOwnerLastName(
  userAdmin: Pick<UserAdminService, 'getUserProfile'>,
  userId: string | undefined,
  cachedLastName?: string,
): Promise<string | undefined> {
  const cached = cachedLastName?.trim();
  if (cached) {
    return cached;
  }

  const id = userId?.trim();
  if (!id) {
    return undefined;
  }

  try {
    const profile = await firstValueFrom(
      userAdmin.getUserProfile(id).pipe(catchError(() => of(null))),
    );
    return profile?.individual?.last_name?.trim() || undefined;
  } catch {
    return undefined;
  }
}
